import { MutableRefObject, RefObject, useLayoutEffect } from "react";

type CursorTarget = {
  inputRef: RefObject<HTMLInputElement | null>;
  cursorRef: MutableRefObject<number | null>;
};

/** Restores cursor selection range on the active input after each render, then clears the stored position. */
export function useCursorRestore(targets: CursorTarget[]): void {
  useLayoutEffect(() => {
    for (const { inputRef, cursorRef } of targets) {
      const inputEl = inputRef.current;
      const cursor = cursorRef.current;

      if (cursor !== null && inputEl && document.activeElement === inputEl) {
        inputEl.setSelectionRange(cursor, cursor);
        cursorRef.current = null;
      }
    }
  });
}
